<template>
    <b-row class="mb-5">
        <b-col md="12">
          <div class="pt-2 pb-2 float-right">
            <a variant="light" style="margin-top:-100px!important; margin-right:10px!important;" class="btn-back btn-custom"></a>
            <!-- <b-button variant="info" style="margin-top:-88px!important;" class="mr-1 btn-download btn-custom" @click="doExportToExcel"><font-awesome-icon icon="download" style="font-size:15px!important;" /></b-button> -->
            <!-- <b-button variant="primary" style="margin-top:-88px!important;" class="btn-back btn-custom" @click="doModal"><font-awesome-icon icon="plus"/></b-button> -->
          </div>
          <paginated-table ref="dataTable" :can-edit="false" :can-delete="false" :can-approve="false" :can-reject="false" :can-show="true" :can-show-route-path="'#/vehicle/repair-detail'" :can-edit-modal="true" :can-repair="false" :can-paid="false" v-on:editData="doEdit" :data-url="apiUrl.vehicleBill" :data-key="dataKey" :data-columns="columns">
          </paginated-table>
        </b-col>
      <!-- <type-vehicle-modal ref="typeVehicleModal" :type-vehicle="'Insurance'" v-on:getInsuranceBill="getInsuranceBill"></type-vehicle-modal> -->
      <edit-repair-modal ref="editRepair" v-on:getRepairBill="getRepairBill"></edit-repair-modal>
    </b-row>
</template>
<script>
  import PaginatedTable from '@/components/PaginatedTable'
  // import TypeVehicleModal from './TypeVehicleModal'
  import EditRepairModal from './EditRepairModal'
  export default {
    props: {
      vehicleUuid: {
        type: String,
        required: false
      }
    },
    components: {
      PaginatedTable,
      // TypeVehicleModal
      EditRepairModal
    },
    data: function() {
      var currentDate = new Date();
      var twoDigitFirstMonth= '01';  
      var twoDigitFirstDate= '01';
      var createdDateTo = currentDate.getFullYear() + "-" + twoDigitFirstMonth + "-" + twoDigitFirstDate;
      
      var currentDate = new Date();
      var twoDigitLastMonth= '12';  
      var twoDigitLastDate= '31';
      var createdDateBy = currentDate.getFullYear() + "-" + twoDigitLastMonth + "-" + twoDigitLastDate;

      return {
        dataKey: "vehicleBillInfo",
        type: "Repair",
        isLoading: false,
        apiUrl: {
          vehicleRequest: window.AppConfig.apiUrl + 'vehicle-request',
          vehicleBill: window.AppConfig.apiUrl + 'vehicle-bill-info?vehicle_uuid=' + this.vehicleUuid + '&type=Repair&start_date=' + createdDateTo + '&end_date=' + createdDateBy,
          exportRepair: window.AppConfig.apiUrl + 'export-vehicle-bill-general'
        },
        columns: [
          // {
          //   label: 'Bill Number',
          //   key: 'billNumber',
          //   sortable: false
          // },
          {
            key: 'issuedBy',
            label: 'Issued By',
            sortable: false
          },
          {
            key: 'createdAtType',
            label: 'Issued Date',
            sortable: false
          },
          {
            key: 'typeDate',
            label: 'Repair Date',
            sortable: false
          },
          {
            key: 'amounts',
            label: 'Amount',
            sortable: false
          },
          {
            key: 'paidDateVehicle',
            label: 'Paid Date',
            sortable: false
          },
          {
            key: 'notes',
            label: 'Note',
            sortable: false
          },
          {
            key: 'statusTypeRepair',
            label: 'Status',
            sortable: false
          },
          {
            key: 'actions',
            label: '',
            sortable: false
          }
        ],
        vehicleRequestList: []
      }
    },
    mounted() {
      this.getRepairBill()
    },
    methods: {
        getRepairBill () {
          this.isLoading = true
          this.$refs.dataTable.getDataTable()
        },
        getDateTime (value) {
            if (value !== null) {
                return this.$moment(value).format('YYYY-MM-DD HH:mm A')
            } else {
                return '-'
            }
        },
        doExportToExcel () {
          let url = this.apiUrl.exportRepair + '?token=' + this.$store.getters['account/tokens'].access_token + '&type=Repair&vehicle_uuid=' + this.vehicleUuid
          
          window.open(url)
        },
        doModal () {
          this.$refs.typeVehicleModal.showModal()
        },
        doEdit (row) {
          this.$refs.editRepair.showModal(row)
        },
        doShowModal (row) {
          this.$refs.editRoadTax.showModal(row)
        },
    }
  }
</script>